





































import { Vue, Prop, Watch, Component } from 'vue-property-decorator'
import * as Types from '../../mini'
@Component({})
export default class CountDown extends Vue {
  @Prop() data: Types.countDownComp
  @Prop() pageData: Types.PageComp

  days: string = '00'
  hours: string = '00'
  minutes: string = '00'
  seconds: string = '00'
  text: string = ''
  interval: any = null
  showCountDown: boolean = true

  @Watch('data.timeRange')
  dataChange(value) {
    if (value && value.length) {
      let timeNow = new Date().getTime()
      if (timeNow <= new Date(value[0].replace(/-/g, '/')).getTime()) {
        this.getRange([timeNow, value[0].replace(/-/g, '/')])
        this.text = this.data.text
        this.showCountDown = true
      } else if (timeNow >= new Date(value[1].replace(/-/g, '/')).getTime()) {
        this.days = '00'
        this.hours = '00'
        this.minutes = '00'
        this.seconds = '00'
        this.text = ''
        this.showCountDown = false
      } else {
        this.getRange([timeNow, value[1].replace(/-/g, '/')])
        this.text = this.data.ingText
        this.showCountDown = true
      }
    }
  }
  created() {
    this.dataChange(this.data.timeRange)
    this.changeText()
    setTimeout(() => {
      this.positonChanged(this.data.position)
    }, 1000)
  }

  @Watch('data.position')
  positonChanged(value) {
    const DOCITEM = document.getElementById(`count-${this.data['_id']}`)
    if (!DOCITEM) return
    let canAddClass = true
    if (value === 'custom') canAddClass = false
    if (canAddClass) {
      DOCITEM.parentElement.classList.add(`count-down-${value}`)
      DOCITEM.parentElement.style.width = '100%'
      if (value === 'bottom') {
        DOCITEM.parentElement.parentElement.style.paddingBottom = '5vh'
      }
      DOCITEM.parentElement.style.position =
        value === 'top' ? 'sticky' : 'fixed'
      DOCITEM.parentElement.style.top = value === 'top' ? '0' : ''
      DOCITEM.parentElement.style.bottom = value === 'bottom' ? '0' : ''
      DOCITEM.parentElement.style.zIndex = value === 'bottom' ? '995' : '10'
      let hasDom = document.getElementById('#spaceDiv')
      if (!hasDom) {
        let spaceDom = document.createElement('div')
        spaceDom.style.width = '100%'
        spaceDom.style.height = '7vh'
        spaceDom.id = 'spaceDiv'
        const DOCITEM = document.getElementById(`count-${this.data['_id']}`)
        DOCITEM.parentElement.parentElement.appendChild(spaceDom)
      }
    } else {
      DOCITEM.parentElement.classList.remove(`count-down-${value}`)
    }
  }

  @Watch('data.text')
  textChange(value) {
    this.changeText()
  }
  @Watch('data.ingText')
  ingTextChange(value) {
    this.changeText()
  }
  changeText() {
    let timeNow = new Date().getTime()
    if (this.data.timeRange && this.data.timeRange.length) {
      if (timeNow <= new Date(this.data.timeRange[0]).getTime()) {
        this.text = this.data.text
      } else if (timeNow >= new Date(this.data.timeRange[1]).getTime()) {
        this.text = ''
      } else {
        this.text = this.data.ingText
      }
    }
  }

  getRange(timeRange) {
    clearInterval(this.interval)
    const firstTime = new Date(timeRange[0]).getTime()
    const secondTime = new Date(timeRange[1]).getTime()
    const time = secondTime - firstTime
    let days = Math.floor(time / (24 * 3600 * 1000))
    let hours = Math.floor((time / (3600 * 1000)) % 24)
    let minutes = Math.floor((time / (60 * 1000)) % 60)
    let seconds = Math.floor((time / 1000) % 60)
    this.days = days >= 10 ? '' + days : '0' + days
    this.hours = hours >= 10 ? '' + hours : '0' + hours
    this.minutes = minutes >= 10 ? '' + minutes : '0' + minutes
    this.seconds = seconds >= 10 ? '' + seconds : '0' + seconds
    this.interval = setInterval(() => {
      if (days < 0) this.showCountDown = false
      this.days = days >= 10 ? '' + days : days < 0 ? '00' : '0' + days
      this.hours = hours >= 10 ? '' + hours : hours < 0 ? '00' : '0' + hours
      this.minutes =
        minutes >= 10 ? '' + minutes : minutes < 0 ? '00' : '0' + minutes
      this.seconds =
        seconds >= 10 ? '' + seconds : seconds < 0 ? '00' : '0' + seconds

      if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
        clearInterval(this.interval)
        this.dataChange(this.data.timeRange)
        return
      }
      seconds--
      if (seconds < 0) {
        seconds = 59
        minutes--
        if (minutes < 0) {
          minutes = 59
          hours--
          if (hours < 0 && days === 0) {
            hours = 23
            days--
            if (days < 0) {
              days = 0
            }
          }
        }
      }
    }, 1000)
  }
}
